<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="120px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.dsn')">
                  <el-input
                    v-model="formselect.dsn"
                    style="width: 100%"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('maintain.timeRange')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button
                  @click="getDataList('search')"
                  type="primary"
                  size="small"
                  >{{ $t("button.query") }}</el-button
                >
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImport") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="exportList()"
              :loading="loading"
              v-if="hasExportAuth"
              >{{ $t("button.exportAll") }}</el-button
            >
            <a
              v-if="activeLang == 'en'"
              v-show="hasImportAuth"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/Excel Import Template -Service Record.xlsx"
              download="Excel Import Template -Service Record.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <a
              v-else
              v-show="hasImportAuth"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-服务记录.xlsx"
              download="EXCEL导入模板-服务记录.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="dsn"
                  :label="$t('desc.dsn')"
                  min-width="100"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="bootTime"
                  :label="$t('maintain.openTime')"
                  min-width="150"
                >
                <template slot-scope="scope">
                  {{ scope.row.bootTime.split('T')[0] }}
                </template>
                </el-table-column>
              <el-table-column
                  prop="seviceTypeName"
                  :label="$t('maintain.maintainType')"
                  min-width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="serviceOrderCode"
                  :label="$t('maintain.orderCode')"
                  min-width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="serviceContent"
                  :label="$t('maintain.serviceContent')"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="runningHour"
                  :label="$t('maintain.runningHour')"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="serviceTime"
                  :label="$t('maintain.serviceTime')"
                  min-width="150"
                >
                <template slot-scope="scope">
                  {{ scope.row.serviceTime.split('T')[0] }}
                </template>
                </el-table-column>

                <!-- <el-table-column
                  :label="$t('title.operate')"
                  :width="hasDownLoadAuth?150:100"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <template>
                      <el-button
                        type="default"
                        icon="el-icon-download"
                        circle
                        size="mini"
                        :title="$t('RunningTIme.DownloadReport')"
                        v-show="hasDownLoadAuth"
                        @click="downLoadFileFromS3(scope.row)"
                      >
                      </el-button>
                    </template>
                  </template>
                </el-table-column> -->
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('title.batchImportServiceHistory'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
  </div>
</template>

<script>
import {
  authOperationCheck,
  getAllMaintainRecord,
  importMaintainRecord,
  exportExcelWithStyle,
  exportMaintainRecordStat,
  getMaintainType 
} from "../../api/api";
import { mapState, mapGetters } from "vuex";
import importComponent from "../../components/content/maintabber/ExportExcelFile";

export default {
  name: "index",
  components: {
    "import-dialog": importComponent,
  },
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData1:[],
      formselect:{},
      hasDownLoadAuth:false,
      hasImportAuth:false,
      hasExportAuth:false,
      dialogImportClient:false,
      form:{},
      importLoading:false,
      loading:false,
      maintainTypeArr:[],
    };
  },
  created: function () {
    this.authOperation("MaintainRecord");
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  async mounted() {
    this.getDataList();
    this.getMaintainType();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasImportAuth = res.hasImportAuth;
      that.hasExportAuth = res.hasExportAuth;
    },
    async getMaintainType(){
      let res = await getMaintainType();
      this.maintainTypeArr = res.result;
    },
    async getDataList(type = "normal") {
      let that = this;
      if (type == "search") {
        that.pagination.current = 1;
      }
      let skipcount = (that.pagination.current - 1) * that.pagination.pageSize;
      let postData = {
        Dsn: that.formselect.dsn,
        Times:that.formselect.times,
        SkipCount: skipcount,
        MaxResultCount: that.pagination.pageSize,
      };
      let res = await getAllMaintainRecord(postData);
      that.pagination.totalPage = res.result.totalCount;
      that.tableData1 = res.result.items;
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDataList();
    },
    resetKeyword(){
      this.formselect = new Object();
    },

    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    find(array, model) {
      var index = array.findIndex((item) => item.Gsn === model.Gsn);
      return index; // -1 说明array中不存在id为str的对象
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      var propertys = Object.keys(datalist[0]);

      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en') {
          obj.Dsn = v["Dsn"];
          obj.BootTime = that.formatDate(v["Boot Time"],'-');
          obj.SeviceType = v["Service Type"];
          obj.ServiceOrderCode = v["Service Order Code"];
          obj.ServiceContent = v["Service Content"];
          obj.ServiceTime = that.formatDate(v["Service Time"],'-');
          obj.RunningHour = v["Running Hour"];
        } else {
          obj.Dsn = v["设备SN号"];
          obj.BootTime = that.formatDate(v["开机时间"],'-');
          obj.SeviceType = v["服务类型"];
          obj.ServiceOrderCode = v["服务编号"];
          obj.ServiceContent = v["服务内容"];
          obj.ServiceTime = that.formatDate(v["维护时间"],'-');
          obj.RunningHour = v["运行时间"];
        }
        
        if(!Number.isFinite(obj.RunningHour)){
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:")+that.$t("importError.runningTimeError"));
        }
        if(!Number.isInteger(obj.RunningHour)){
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:")+that.$t("importError.runningTimeinteger"));
        }
        if (obj.Dsn == undefined || obj.Dsn == "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:")+that.$t("importError.devicesnIsEmpty"));
        } else {
          if (that.find(postData, obj) > -1) {
            // msgArr.push(
            //   "Excel表格读取数据第" +
            //     index +
            //     "行异常，已存在相同的设备SN号" +
            //     obj.Dsn
            // );
          } else {
            
          }
          postData.push(obj);
        }
        index++;
      });
      console.log(postData);
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importMaintainRecord(postData, 2 * 60 * 1000)
        .then((res) => {
          this.importLoading = false;
          that.dialogImportClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          this.importLoading = false;
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    formatDate2(numb,format){
      const time = new Date((numb-1)*24*3600000+1);
      time.setYear(time.getFullYear()-70)
      const year = time.getFullYear();
      const month = time.getMonth()+1;
      const date = time.getDate();
      let result = year + format + (month < 10?('0'+month):month)+format+(date<10?('0'+date):date);
      return result; 
    },
    formatDate(numb,format){
      const old = numb - 1; 
      const t = Math.round((old-Math.floor(old))*24*3600);
      const time = new Date(1900, 0, old, 0, 0, 1);
      const year = time.getFullYear();
      const month = time.getMonth()+1;
      const date = time.getDate();
      let result = year + format + (month < 10?('0'+month):month)+format+(date<10?('0'+date):date);
      return result; 
    },
    async exportList() {
      let that = this;
      let th2 = new Object();
      let th3 = new Object();
      if (this.activeLang == "en") {
        th2 = {
          "empty":{
            length:6,
          },
          "Oil Filter":{
            length:6,
            fgColor:"FFE699"
          },
          "Oil Separator":{
            length:6,
            fgColor:"C6E0B4"
          },
          "Air Filter":{
            length:6,
            fgColor:"BDD7EE"
          },
        }
        th3 = {
          "Gsn":{length:1},
          "Dsn":{length:1},
          "Air Compressor Type":{length:1, fgColor:"A6A6A6"},
          "Ccn":{length:1, fgColor:"A6A6A6"},
          "Binding Time":{length:1, fgColor:"A6A6A6"},
          "Boot Time":{length:1},
          "Last replacement time of Oil Filter":{length:1, fgColor:"FFE699"},
          "Service Content$$001":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$001":{length:1, fgColor:"A6A6A6"},
          "Last second replacement time of Oil Filter":{length:1, fgColor:"FFE699"},
          "Service Content$$002":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$002":{length:1, fgColor:"A6A6A6"},
          "Last replacement time of Oil Separator":{length:1, fgColor:"C6E0B4"},
          "Service Content$$003":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$003":{length:1, fgColor:"A6A6A6"},
          "Last second replacement time of Oil Separator":{length:1, fgColor:"C6E0B4"},
          "Service Content$$004":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$004":{length:1, fgColor:"A6A6A6"},
          "Last replacement time of Air Filter":{length:1, fgColor:"BDD7EE"},
          "Service Content$$005":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$005":{length:1, fgColor:"A6A6A6"},
          "Last second replacement time of Air Filter":{length:1, fgColor:"BDD7EE"},
          "Service Content$$006":{length:1, fgColor:"A6A6A6"},
          "Service Order Number$$006":{length:1, fgColor:"A6A6A6"},
        }
      } else {
        th2 = {
          "empty":{
            length:6,
          },
          "油滤":{
            length:6,
            fgColor:"FFE699"
          },
          "油分":{
            length:6,
            fgColor:"C6E0B4"
          },
          "空滤":{
            length:6,
            fgColor:"BDD7EE"
          },
        }
        th3 = {
          "网关SN号":{length:1},
          "序列号":{length:1},
          "空压机型号":{length:1, fgColor:"A6A6A6"},
          "CCN号":{length:1, fgColor:"A6A6A6"},
          "绑定时间":{length:1, fgColor:"A6A6A6"},
          "开机时间":{length:1},
          "最近一次更换油滤时间":{length:1, fgColor:"FFE699"},
          "服务内容$$001":{length:1, fgColor:"A6A6A6"},
          "服务单号$$001":{length:1, fgColor:"A6A6A6"},
          "最近第二次更换油滤时间":{length:1, fgColor:"FFE699"},
          "服务内容$$002":{length:1, fgColor:"A6A6A6"},
          "服务单号$$002":{length:1, fgColor:"A6A6A6"},
          "最近一次更换油分时间":{length:1, fgColor:"C6E0B4"},
          "服务内容$$003":{length:1, fgColor:"A6A6A6"},
          "服务单号$$003":{length:1, fgColor:"A6A6A6"},
          "最近第二次更换油分时间":{length:1, fgColor:"C6E0B4"},
          "服务内容$$004":{length:1, fgColor:"A6A6A6"},
          "服务单号$$004":{length:1, fgColor:"A6A6A6"},
          "最近一次更换空滤时间":{length:1, fgColor:"BDD7EE"},
          "服务内容$$005":{length:1, fgColor:"A6A6A6"},
          "服务单号$$005":{length:1, fgColor:"A6A6A6"},
          "最近第二次更换空滤时间":{length:1, fgColor:"BDD7EE"},
          "服务内容$$006":{length:1, fgColor:"A6A6A6"},
          "服务单号$$006":{length:1, fgColor:"A6A6A6"},
        }
      }
      
      let th4 = {
        "empty":{
          length:1,
        },
      }
      

      let fileName = that.$t("exportContent.维护记录表") + ".xlsx";
      let res = await exportMaintainRecordStat();
      let typeList = res.result.codeList;
      let codeNameArr = res.result.serviceTypeList;

      let data = res.result.maintainDeviceList;
      //动态设置标题
      let fgColor = "FFE699";
      let cellNumber = 1;
      

      typeList.forEach(x=>{
        if(x != "油滤" && x != "油分" && x != "空滤"){
          let th2obj = {
            length:3,
            fgColor:fgColor
          };
          let th3obj = {length:1, fgColor:fgColor};
          let th3obj2 = {length:1, fgColor:"A6A6A6"};
          fgColor = (fgColor=="FFE699"?"F8CBAD":"FFE699");
          if (this.activeLang == "en") {
            let displayTypeName = this.maintainTypeArr.find(item=>item.bnDictName == x)?.bnDictCode??x
            this.$set(th2, displayTypeName +"$$00" + cellNumber, th2obj);
            this.$set(th3, "Last second replacement time of " + displayTypeName +"$$00" + cellNumber, th3obj);
            this.$set(th3, "Service Order Code$$00"+cellNumber, th3obj2);
            this.$set(th3, "Running Hour$$00"+cellNumber, th3obj2);
          } else {
            this.$set(th2, (codeNameArr[x]?codeNameArr[x]:x) +"$$00" + cellNumber, th2obj);
            this.$set(th3, "最近一次维护时间"+ x +"$$00" + cellNumber, th3obj);
            this.$set(th3, "服务编号$$00"+cellNumber, th3obj2);
            this.$set(th3, "运行时间$$00"+cellNumber, th3obj2);
          }
          
          cellNumber++;
        }
        
      });
      let th = {
        "empty":{
          length:6,
        },
        "Comsumable Parts: 两周更新一次":{
          length:18,
        },
        "Hard Parts: 一个月更新一次":{
          length:(typeList.length-3)*3,
        }
      }

      var thData = new Array();
      thData.push(th4);//第一行空行
      // thData.push(th);//第二行标题
      thData.push(th2);//第三行标题
      thData.push(th3);//第四行标题

      //导入数据里有null会导致文件损坏
      // const dataSource = data.map((item) => {
      //   Object.keys(item).forEach((key) => {
      //     // 后端传null node写入会有问题
      //     if (item[key] === null) {
      //       item[key] = "";
      //     }
      //     if (Array.isArray(item[key])) {
      //       item[key] = item[key].join(",");
      //     }
      //   });
      //   return item;
      // });
      let exportData=new Array();
      data.forEach((item) => {
        let rowData = [];
        // let dianji = item.maintainDetailList.find(x=>x.serviceType == "CA2 / CB2");
        // let midCold = item.maintainDetailList.find(x=>x.serviceType == "BA / BD");
        // let backCold = item.maintainDetailList.find(x=>x.serviceType == "BB / BE");
        // let oilCold = item.maintainDetailList.find(x=>x.serviceType == "BC / BC2");
        // let oilGas = item.maintainDetailList.find(x=>x.serviceType == "HC");
        // let jinqi = item.maintainDetailList.find(x=>x.serviceType == "AS");
        // let wenkong = item.maintainDetailList.find(x=>x.serviceType == "BF");
        // let yali = item.maintainDetailList.find(x=>x.serviceType == "FK");
        // let fangkong = item.maintainDetailList.find(x=>x.serviceType == "HG");

        let youfen = item.maintainDetailList.find(x=>x.serviceType == "油分");
        let youlv = item.maintainDetailList.find(x=>x.serviceType == "油滤");
        let konglv = item.maintainDetailList.find(x=>x.serviceType == "空滤");
        rowData = [
          item.gsn,
          item.dsn,
          item.deviceModel,
          item.ccn,
          item.bindTime,
          item.bootTime,
          youlv?.lastServiceTime,youlv?.serviceContent,youlv?.serviceCode,'','','',
          youfen?.lastServiceTime,youfen?.serviceContent,youfen?.serviceCode,'','','',
          konglv?.lastServiceTime,konglv?.serviceContent,konglv?.serviceCode,'','','',
          // dianji?.lastServiceTime, dianji?.serviceCode, dianji?.runningHour,
          // midCold?.lastServiceTime, midCold?.serviceCode, midCold?.runningHour,
          // backCold?.lastServiceTime, backCold?.serviceCode, backCold?.runningHour,
          // oilCold?.lastServiceTime, oilCold?.serviceCode, oilCold?.runningHour,
          // oilGas?.lastServiceTime, oilGas?.serviceCode, oilGas?.runningHour,
          // jinqi?.lastServiceTime, jinqi?.serviceCode, jinqi?.runningHour,
          // wenkong?.lastServiceTime, wenkong?.serviceCode, wenkong?.runningHour,
          // yali?.lastServiceTime, yali?.serviceCode, yali?.runningHour,
          // fangkong?.lastServiceTime, fangkong?.serviceCode, fangkong?.runningHour,
        ];
        typeList.forEach(type=>{
          if(type != "油滤" && type != "油分" && type != "空滤"){
            let curData = item.maintainDetailList.find(x=>x.serviceType == type);
            rowData.push(curData?.lastServiceTime);
            rowData.push(curData?.serviceCode);
            rowData.push(curData?.runningHour);
          }
        })
        exportData.push(rowData);
      });
      let rowData = [];
      
      exportData.push(rowData)
      exportExcelWithStyle(thData,exportData,fileName);
      that.loading=false;
    },
  },
};
</script>

 